import React, { FunctionComponent, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import PollabProgressLayout from '../../ProgressLayout'
import { PollabBaseOptionProps } from '../BaseOption'
import { TestID } from '../../../utils/PropTypesDefinitions'
import SmallTeaserHeadlineFont from '../../../Theme/Fonts/SmallTeaserHeadline'
import Image from '../../../BaseComponents/Image'

export type PollabOptionWithImageProps = {
    /** string to determine the imageUrl. if not given Image will use a placeholder */
    imageUrl?: string
    /** info about imageUrl for seo */
    alt?: string
} & PollabBaseOptionProps &
    TestID

const PollabOptionWithImage: FunctionComponent<PollabOptionWithImageProps> = ({
    imageUrl,
    alt,
    label,
    result,
    selected,
    disabled,
    onPress,
    percent,
    testID,
}) => {
    const touchable = !disabled && onPress

    const component = (
        <PollabProgressLayout progress={percent} testID={!touchable ? testID : undefined}>
            <Grid horizontal centerVertical noExpand>
                {selected ? (
                    <FontelloIcon color="BLACK" name="check-active" paddingX={1} />
                ) : (
                    <Grid height={19} width={19} noExpand>
                        <Image
                            size="S"
                            imageUrl={imageUrl}
                            alt={alt}
                            radiusType="circled"
                            aspectRatio="1:1"
                        />
                    </Grid>
                )}
                <Grid paddingX={3}>
                    <SmallTeaserHeadlineFont bold={selected}>{label}</SmallTeaserHeadlineFont>
                </Grid>
                {result ? (
                    <Grid noExpand alignRight>
                        <SmallTeaserHeadlineFont bold={selected}>{result}</SmallTeaserHeadlineFont>
                    </Grid>
                ) : null}
            </Grid>
        </PollabProgressLayout>
    )

    if (touchable) {
        return (
            <Touchable onPress={onPress} pointer testID={testID}>
                {component}
            </Touchable>
        )
    }
    return component
}

export default memo(PollabOptionWithImage)
